<div *ngIf="themeData" class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <a class="layout-topbar-logo" routerLink="/admin">
            <img *ngIf="!layoutService.isDarkTheme() && themeData.theme_logo" [src]="themeData.theme_logo" alt="Logo"
                class="topbar-logo layout-topbar-logo-img" />
            <img *ngIf="layoutService.isDarkTheme() && themeData.theme_logo_dark" [src]="themeData.theme_logo_dark" alt="Logo"
                class="topbar-logo layout-topbar-logo-img" />
            <span>{{ themeData.theme_title }}</span> <small class="text-red-400"><sup>Admin</sup></small>
        </a>
    </div>

    <p-menubar breakpoint="1100px" [model]="items"></p-menubar>

    <div class="layout-topbar-actions">
        <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="&#64;next" enterFromClass="hidden"
            enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu">
            <div class="layout-topbar-menu-content">

                <div *ngIf="sessionData && sessionData.isLoggedIn" class="layout-topbar-menu-content-user">
                    <span class="username">{{ sessionData.user.name }}</span>
                    <span *ngIf="sessionData.actor" class="impersonation-badge"
                        [pTooltip]="'Sie sind als ' + sessionData.actor.name + ' angemeldet und sehen die App aktuell als ' + sessionData.user.name + '.'"
                        tooltipPosition="bottom">
                        <i class="pi pi-user-edit impersonation-badge__icon"></i>
                        <span class="impersonation-badge__text">
                            <span class="impersonation-badge__label">Nachahmung</span>
                            <span class="impersonation-badge__name">{{ sessionData.actor.name }}</span>
                        </span>
                    </span>
                </div>

                <div class="flex justify-center">
                    <app-user-menu-dropdown />
                </div>

                <p-button *ngIf="!sessionData || !sessionData.isLoggedIn" [routerLink]="['/login']" label="{{ 'common.cancel' | translate }}" icon="pi pi-sign-in" [raised]="true" severity="secondary"
                    styleClass="profile-btn" class="self-end mt-2" type="button" />
            </div>
        </div>
    </div>
</div>
